module.exports = __webpack_public_path__ + "static/media/banner_mobile.813da399.png";